module.exports = {"id":"dp4_1l1q5","text":"Protecting Devices","instructions":"Cybersecurity laws mainly exist to:","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l1q5-a1","text":"Protect users and services","score":1.8},{"id":"dp4_1l1q5-a2","text":"Control device ownership","score":0},{"id":"dp4_1l1q5-a3","text":"Limit internet access","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l1q5.json
// module id = 1206
// module chunks = 41